import { Badge } from 'foundations-components/transitional/components/Badge';
import { Avatar } from 'avatar-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SharingListItem } from './SharingListItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserListItem = ({
  displayName,
  email
}) => {
  return /*#__PURE__*/_jsx(SharingListItem, {
    testId: "user-list-item",
    avatar: /*#__PURE__*/_jsx(Avatar, {
      size: "sm",
      hubSpotUserEmail: email,
      displayName: displayName
    }),
    primaryText: displayName,
    secondaryText: email,
    badge: /*#__PURE__*/_jsx(Badge, {
      use: "pantera",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.sharingPanel.ownerBadge"
      })
    })
  });
};